import { INVALIDATE_COMPTE_PAIEMENT } from 'actions/invalidationTags';
import { ApiMananger } from 'actions/rtkquery';
import {
  ADD_COMPTE_PAIEMENT_API_ROUTE,
  UPDATE_COMPTE_PAIEMENT_API_ROUTE,
  DELETE_COMPTE_PAIEMENT_API_ROUTE,
} from 'routes/api/endpoints';

const compte_paiementApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    // Mutation for creating a new client instance
    createComptePaiement: build.mutation({
      query(body) {
        return {
          url: ADD_COMPTE_PAIEMENT_API_ROUTE,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: [INVALIDATE_COMPTE_PAIEMENT],
    }),

    // Mutation for updating an existing client instance
    updateComptePaiement: build.mutation({
      query: ({ id, ...updateData }) => ({
        url: `${UPDATE_COMPTE_PAIEMENT_API_ROUTE}${id}/`,
        method: 'PUT',
        body: updateData,
      }),
      invalidatesTags: [INVALIDATE_COMPTE_PAIEMENT], // Invalidate the cache tags to refetch client-related data
    }),

    // Mutation for deleting an existing client instance
    deleteComptePaiement: build.mutation({
      query: ({id}) => ({
        url: `${DELETE_COMPTE_PAIEMENT_API_ROUTE}${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [INVALIDATE_COMPTE_PAIEMENT], // Invalidate to refetch client-related data
    }),

    // More client-related mutations and queries can be added here...
  }),
  overrideExisting: false,
});

export const {
  useCreateComptePaiementMutation,
  useUpdateComptePaiementMutation,
  useDeleteComptePaiementMutation,
} = compte_paiementApi;
